import './join.scss';

export default () => {

};
